// Read and JSON-parse a localStorage entry, returning null on a missing key or
// malformed JSON.
export const safeParseStorage = (key: string): unknown => {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};
